<template>
  <div class="form-group combobox-search-check">
    <div class="content"
         v-click-outside="onClose">
      <div class="input-contenedor" :class="{open: open}"
           @click="open = true">
        <input v-model="search" type="text" class="form-control"
               :placeholder="placeholderText"
               ref="input"
               :title="placeholderText"/>
        <iconify-icon class="vue-select-icono" icon="mingcute:down-line"></iconify-icon>
      </div>

      <ul class="items-list"
          :class="{activo: open}">
        <li v-if="optionsFilter.length == 0" class="no-options">
          No se encontraron resultados
        </li>
        <li v-for="opcion in optionsFilter" class="item"
            @click="addSelection(opcion)"
            :class="{activo: added(opcion)}"
            :key="opcion.code">
          <label class="checkbox-cm">
            <input type="checkbox" :checked="added(opcion)" readonly
                   @click="addSelection(opcion)">
            <span class="check-mark">
                        <img src="/assets/imagenes/iconos/ic_check_white.svg" :alt="opcion.label">
                    </span>
          </label>
          <span class="titulo-opcion">{{ opcion.label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SelectCheck',
  model: {

  },
  props: {
    options: {
      type: Array,
      default() {
        return []
      },
    },
    value: [],
    placeholder: {
      type: String,
      default: '',
    },
  },
  watch: {
    value(){
      this.generatePlaces();
    }
  },
  data: function(){
    return {
      search: '',
      open: false,
      placeholderText: this.placeholder
    }
  },
  mounted() {
  },
  methods: {
    onClose () {
      if(this.open){
        this.open = false;
      }
    },
    change: function () {
      this.$emit("change");
    },
    setSelected: function (selected) {
      selected.checked = !selected.checked;
      this.change();
    },
    optionIndexAdded(option){
      return this.value.findIndex(item => item.code == option.code)
    },
    added(option){
      return this.optionIndexAdded(option) > -1
    },
    addSelection(option){
      let values = Object.assign([], this.value)
      let index = this.optionIndexAdded(option)
      if(index > -1){
        values.splice(index, 1)
      }
      else{
        values.push(option)
      }
      this.$emit('input', values)
      if(values.length === this.options.length){
        this.open = false
      }
    },
    generatePlaces () {
      this.placeholderText = this.value.reduce(function (place, dt) {
        return place += "" + dt.label + ", ";
      }, "");

      if(this.placeholderText === ""){
        this.placeholderText = this.placeholder;
      }
      else{
        this.placeholderText = this.placeholderText.substring(0, this.placeholderText.length - 2);
      }
    },
  },
  computed: {
    optionsFilter(){
      let vue = this;
      return this.options.filter(function (dt) {
        return dt.label.toLowerCase().indexOf(vue.search.toLowerCase()) !== -1
      });
    }
  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.combobox-search-check{



  .content{
    position: relative;

    .input-contenedor{
      position: relative;
      &.open{
        .vue-select-icono{
          transform: rotate(180deg) scale(1) translateY(50%);
        }
      }
      .vue-select-icono{
        position: absolute;
        right: 7px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 25px;
        color: rgba(60, 60, 60, 0.5);
        transition: transform 0.15s cubic-bezier(1,0.5,0.8,1);
      }
      input{
        outline: none;
        box-shadow: none;
        padding: 16px 16px;
        padding-right: 35px;
        border-radius: 16px;
        border-color: #E0E2E6;
        color: rgb(33, 37, 41);
        font-size: 16px;
        &::placeholder {
          color: #969ba4;
          opacity: 1; /* Firefox */
        }

        &::-ms-input-placeholder { /* Edge 12 -18 */
          color: #969ba4;
        }
      }
    }

    //.form-control{
    //    outline: none;
    //    box-shadow: none;
    //    border-radius: 50px;
    //
    //}

    .items-list{
      background: #fff;
      border: none;
      border-radius: 4px;
      box-shadow: 0 3px 6px 0 rgba(0,0,0,0.15);
      box-sizing: border-box;
      color: #484848;
      display: block;
      left: 0;
      list-style: none;
      margin: 0;
      max-height: 350px;
      min-width: 160px;
      overflow-y: auto;
      padding: 5px 0;
      position: absolute;
      text-align: left;
      top: calc(100% - 1px);
      width: 100%;
      z-index: 1000;
      transition-duration: 0.2s;
      opacity: 0;
      visibility: hidden;
      &.activo{
        opacity: 1;
        visibility: visible;
      }

      //.no-options{
      //  text-align: center;
      //}

      .item{
        cursor: pointer;
        color: #484848;
        border-radius: 4px;

        clear: both;
        display: flex;
        width: 100%;
        flex-direction: row;
        gap: 12px;
        line-height: 1.42857143;
        padding: 10px 20px;
        white-space: nowrap;
        .titulo-opcion{
          padding-top: 3px;
        }
      }

    }

  }


}

</style>
